var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useToggle } from '@hn-front/utils';
import { Grades } from '@hn-front/data-types';
import { styled } from 'styled-components';
import { Down, Up, Play } from '@hn-ui/icons';
import { format, parseISO } from 'date-fns';
import { TextButton } from '@hn-ui/buttons';
import { Badge } from '../Badge';
import { LeaderBoard } from '../leaderboard/LeaderBoard';
import { TitleContainer, Description, ChallengeText, ChallengeTitle, ChallengeContainer, Controls, } from '../Common';
import { useLeaderboard } from '../../api';
import { DownloadButton } from './DownloadButton';
var PresentLink = styled(TextButton).withConfig({ displayName: "PresentLink", componentId: "sc-11g20zh" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var DetailsButton = styled(TextButton).withConfig({ displayName: "DetailsButton", componentId: "sc-my4uay" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var DownloadControls = styled.div.withConfig({ displayName: "DownloadControls", componentId: "sc-dq8b7c" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  gap: 32px;\n  margin-left: auto;\n"], ["\n  display: flex;\n  gap: 32px;\n  margin-left: auto;\n"])));
var Completed = function (_a) {
    var id = _a.id, startDate = _a.startDate, endDate = _a.endDate, grades = _a.grades, author = _a.author, certificateUrl = _a.certificateUrl, leaderBoardPath = _a.leaderBoardPath, currentTeacherId = _a.currentTeacherId, rest = __rest(_a, ["id", "startDate", "endDate", "grades", "author", "certificateUrl", "leaderBoardPath", "currentTeacherId"]);
    var _b = useToggle(), isExpanded = _b.isToggled, toggleExpand = _b.toggle;
    var data = useLeaderboard(id, currentTeacherId, isExpanded).data;
    var start = format(parseISO(startDate), 'MMM dd');
    var end = format(parseISO(endDate), 'MMM dd');
    var gradesStr = grades.map(function (g) { return Grades[g].full; }).join(', ');
    return (_jsxs(ChallengeContainer, __assign({ color: 'purple50' }, rest, { children: [_jsxs(Description, { children: [_jsxs(TitleContainer, { children: [_jsxs(ChallengeTitle, { children: [start, " - ", end] }, void 0), _jsx(Badge, { state: 'completed' }, void 0)] }, void 0), _jsxs(ChallengeText, { children: ["4-week Math Challenge for ", gradesStr] }, void 0), _jsxs(Controls, { children: [_jsxs(ChallengeText, { children: ["Started by ", author] }, void 0), _jsxs(DownloadControls, { children: [_jsx(DownloadButton, { certificateUrl: certificateUrl }, void 0), leaderBoardPath && (_jsx(PresentLink, __assign({ onClick: function () { return window.open(leaderBoardPath, '_blank'); }, LeftIcon: Play, fit: true }, { children: "Present" }), void 0)), _jsx(DetailsButton, __assign({ fit: true, onClick: toggleExpand, LeftIcon: isExpanded ? Up : Down }, { children: "Details" }), void 0)] }, void 0)] }, void 0)] }, void 0), isExpanded && data && _jsx(LeaderBoard, { data: data }, void 0)] }), void 0));
};
export { Completed };
var templateObject_1, templateObject_2, templateObject_3;
